export async function summaryTransitYBIUseCase(year, month, client_id, shipping_service, yegoDashboardRepository) {
    const result = await yegoDashboardRepository.summaryTransitYBI(year, month, client_id, shipping_service);
    
    const info = await new yegoDashboardRepository.summary_model(result.data);

    if (!info.isValid()) {
        throw new Error("Summary Transit Answer Inválido");
    }

    return result.data;
}